import View from "../common/components/Select";
import components from "./components.js";
components.define("js-select", View);